import Marquee from "react-fast-marquee";
import higCortPermissionImg from "../../assets/images/AGM HighCourt Permission.png";
import { fpRealaatedArticales } from "../../data/relatedArticale";
import Faq from "../Faq";
import Meta from "../Meta";

export default function AGMHighCourtPermission() {
   const faqItems = [
    {
        title: 'What is AGM High Court Permission?',
        content: <strong>AGM High Court Permission refers to the process of seeking legal authorization from the High Court to hold an Annual General Meeting (AGM) under special circumstances where a company is unable to conduct its AGM within the prescribed timeline.</strong>
    },
    {
        title: 'When is High Court permission required for AGM?',
        content: <strong>High Court permission is usually required when a company cannot convene its AGM due to legal, administrative, or unavoidable issues that prevent compliance with standard regulatory timelines.</strong>
    },
    {
        title: 'What documents are needed for High Court permission?',
        content: <strong>Documents may include the petition, board resolution, previous AGM records, explanations for delay, audited financials, and other supporting evidence demonstrating the need for an extension or permission.</strong>
    }
];
 return (
        <>
            <Meta 
                title="AGM High Court Permission in Bangladesh | JK Associates"
                description="In Bangladesh, if a company is unable to hold its Annual General Meeting (AGM) on time, it can apply to the High Court Division for permission to hold a delayed AGM."
                image={higCortPermissionImg}
                keywords="AGM, High Court permission, legal approval, annual general meeting, JK Associates"
            />

            <div className="container-fluid hero-header bg-light py-5 mb-5">
                <div className="container py-5">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6">
                            <h1 className="display-4 mb-3 animated slideInDown">AGM High Court Permission</h1>
                        <p>If a company is unable to hold its Annual General Meeting (AGM) on time, it can apply to the High Court Division for permission to hold a delayed AGM. This is typically done under Section 81(2) of the Companies Act, 1994, The court may also grant extensions for holding the AGM if sufficient cause is shown.</p>
                        </div>
                        <div className="col-lg-6 animated fadeIn">
                            <img className="img-fluid animated pulse infinite" style={{ animationDuration: '3s' }} src={higCortPermissionImg} alt='agm-high-court-permission' />
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <p className="color-text fs-5 mb-4">
                        <b>AGM High Court Permission in Bangladesh</b>
                    </p>
                    <p>
                        In certain circumstances, a company may be unable to hold its Annual General Meeting (AGM) within the required time due to unforeseen legal or procedural issues. In such cases, the company can apply to the High Court for permission to conduct the AGM on a later date. This process involves legal documentation, representation, and justification for the delay.
                    </p>
                    <p>
                        Seeking permission from the High Court ensures that the company remains in compliance with corporate laws and avoids penalties or other legal consequences. It is a legal remedy available to companies under the Companies Act and related regulations.
                    </p>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6">
                            <img className="img-fluid" src={higCortPermissionImg} alt='agm-permission-procedure' />
                        </div>
                        <div className="col-lg-6">
                            <div className="h-100">
                                <p className="color-text fs-5 mb-4">
                                    Services Offered by JK Associates
                                </p>
                                <p>
                                    We provide complete assistance for obtaining AGM High Court Permission:
                                    <div className="d-flex align-items-center mb-2">
                                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                        <span><b>Legal Consultation: </b>Initial evaluation and legal assessment of the need for High Court intervention.</span>
                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                        <span><b>Document Preparation: </b>Drafting petitions, affidavits, board resolutions, and other required legal documents.</span>
                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                        <span><b>Court Representation: </b>Appearing before the High Court on behalf of the company to obtain the required permission.</span>
                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                        <span><b>Compliance Monitoring: </b>Ensuring that court directives are followed and the AGM is held within the permitted timeline.</span>
                                    </div>
                                    <div className="d-flex align-items-center mb-2">
                                        <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                                        <span><b>Post-Permission Support: </b>Support with conducting the AGM, filing required documents, and reporting.</span>
                                    </div>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                    <p>
                        In Bangladesh, an Annual General Meeting (AGM) is a mandatory yearly gathering for companies to review their performance and make important decisions. The Companies Act 1994 outlines the requirements for holding an AGM, including timelines, procedures, and documentation. The Companies must hold an AGM within six months of the end of their financial year. 
                        An AGM must be held at least once a year, with no more than fifteen months between consecutive AGMs. Shareholders must receive a written notice at least fourteen days before the AGM. For special resolutions (requiring a supermajority), the notice period is twenty-one days.
                    </p>
            <div className='container-xxl center-background1'>
                <h2> Related Articles</h2>
            </div>

            <div className='container-xxl center-background1'>
                <Marquee className="marquee-container">
                    {fpRealaatedArticales}
                </Marquee>
            </div>

            <div className="container py-5 my-0">
                <h2 className="color-text text-center mb-4">AGM High Court Permission FAQ</h2>
                <Faq items={faqItems} />
            </div>
        </>
    );
}
